module.exports = __webpack_public_path__ + "static/logo-full-53bab3fd2afa43cd44adffe83d3c9ee5.svg";